import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { SalesDocumentTemplateForSelectFragment } from 'generated/resources/graphql'

export function mapToFinanceSalesDocumentTemplateFragment(
  selected: EntitySelectEntity,
  available: SalesDocumentTemplateForSelectFragment[]
): SalesDocumentTemplateForSelectFragment {
  const entity = available.find((a) => a.id === selected.id)

  // This should never happen
  if (!entity) {
    throw new Error('Sales document template not found')
  }

  return {
    __typename: 'FinanceSalesDocumentTemplate',
    id: String(entity.id),
    name: entity.name,
    footer: entity.footer,
    legalEntity: entity.legalEntity,
    logoFile: entity.logoFile,
    default: entity.default,
  }
}

export function mapFinanceSalesDocumentTemplates(
  financeSalesDocumentTemplates: SalesDocumentTemplateForSelectFragment[]
): EntitySelectEntity[] {
  return financeSalesDocumentTemplates.map((element) => {
    return {
      id: element.id,
      name: element.name,
      default: element.default,
      footer: element.footer,
      legalEntity: element.legalEntity,
      logoFile: element.logoFile,
    }
  })
}
